export default "__VITE_ASSET__ea3ded6e__"